let $b8d1bbecb797e010$var$init = function() {
    function showAllTags() {
        document.querySelectorAll('.is-hidden-tag').forEach((tagElement)=>{
            tagElement.classList.remove("is-hidden-tag", "is-hidden");
        });
        this.remove();
    }
    document.getElementById("showAllTagsButton").addEventListener('click', showAllTags);
};
window.addEventListener("load", $b8d1bbecb797e010$var$init, false);


//# sourceMappingURL=record.js.map
